import { Translate } from 'i18n';
import { FC, useId } from 'react';
import styled from 'styled-components';
import { ThemeSegments } from 'students/views/shared/providers/Theme';
import { menuItemRow } from './profileMenuStyles';

export const AppearanceSwitch: FC = () => {
  const labelId = useId();

  return (
    <SRow>
      <SLabel id={labelId}>
        <Translate
          str="frontend.profile.navigation.appearance"
          params={{ defaultValue: 'Appearance' }}
        />
      </SLabel>

      <ThemeSegments labelledBy={labelId} />
    </SRow>
  );
};

const SRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  ${menuItemRow}
`;

const SLabel = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: normal;
  letter-spacing: -0.02em;
`;
